import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';

import Receipt from '@material-ui/icons/Receipt';

import { BlueRightArrowIcon } from '../../../../images/icons/WrapSvg';

class Reference extends React.Component {
    handleClick = (event) => {
        this.props.history.push('/manage/references/' + this.props.reference.id);
    };

    render() {
        const { reference, active, last } = this.props;
        const nombre = reference.nombre.toUpperCase().trim();
        return (
            <div
                className={
                    'flex_full_row padding_top_24 padding_left_12 margin_left_24 c_grey_blue hand ' +
                    (active ? 'active' : '')
                }
                onClick={this.handleClick}
            >
                <Receipt className={'c_bluish margin_right_12'} />
                <div
                    className={classNames(
                        'flex_full_row align_center',
                        last ? 'noshadow' : 'shadow_down',
                    )}
                >
                    <div className={'flex_full_row '}>
                        <span className="barlow_medium c_dark_grey_blue">{nombre}</span>
                    </div>
                    <BlueRightArrowIcon color="primary" />
                </div>
            </div>
        );
    }
}

Reference.propTypes = {
    history: PropTypes.object.isRequired,
};

export default withRouter(Reference);



// WEBPACK FOOTER //
// ./src/components/complex/manage/references/Reference.js